import { Collaboration, Creator } from '../../../../gql/types'
import { Icon, IconType, Slider } from '../../../../components'
import { Divider } from '../../../../components/Divider'
import { PortfolioGridNew } from '../../../../components/PortfolioGridNew'

interface IProps {
  open: boolean
  setOpen: any
  creator: Creator
  collaboration?: Collaboration
  onCollaborationAccepted?: () => void
  className?: string
}

const ViewPortfolioSliderPublic = ({
  open,
  setOpen,
  creator,
  className,
}: IProps) => {
  return (
    <Slider setOpen={setOpen} open={open} size='4xl'>
      <div
        className={`flex h-full flex-col overflow-y-auto bg-white shadow-xl w-fit fixed right-0 ${className}`}
      >
        {/* Header */}
        <div className='sticky top-0 z-10 bg-white'>
          <div className='px-4 pt-6 sm:px-6'>
            <div className='flex items-start justify-between'>
              <h3 className='text-xl font-bold text-gray-900'>
                {creator?.firstName}'s Portfolio
              </h3>
              <div className='ml-3 flex h-7 items-center'>
                <button
                  type='button'
                  className='rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none'
                  onClick={() => setOpen(false)}
                >
                  <span className='sr-only'>Close panel</span>
                  <Icon
                    type={IconType.x}
                    className='h-6 w-6'
                    aria-hidden='true'
                  />
                </button>
              </div>
            </div>
          </div>
          <Divider className='py-6' />
        </div>

        {/* Main */}
        <div className='flex-1 px-4 sm:px-6 pb-6 overflow-auto'>
          <div className='w-full'>
            <PortfolioGridNew creator={creator} useWindow={false} />
          </div>
        </div>
      </div>
    </Slider>
  )
}

export { ViewPortfolioSliderPublic }
